export {
  EMPTY_WORKSPACE_CONTEXT_VALUE,
  WorkspaceProvider,
  useOptionalWorkspaceContext,
  useWorkspaceContext,
} from "../scope/contexts/WorkspaceContext"
export type { WorkspaceContextValue } from "../scope/contexts/WorkspaceContext"
